import { axiosInstance } from "../../Utils/AxiosInstance";

export const GetAllStockApi = async (materialId) => {
  try {
    const url = materialId ? `/Store/Stock/GetAll?materialId=${materialId}` : `/Store/Stock/GetAll`;
    const response = await axiosInstance.get(url);
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetStockReportApi = (projectId, fromDate, toDate) =>
  axiosInstance.get("/Store/Stock/Report", {
    params: {
      projectId: projectId || undefined,
      fromDate: fromDate || undefined,
      toDate: toDate || undefined,
    },
  });
